import { render, staticRenderFns } from "./InvoiceExcelDashboard.vue?vue&type=template&id=2e1cf132&scoped=true"
import script from "./InvoiceExcelDashboard.vue?vue&type=script&lang=js"
export * from "./InvoiceExcelDashboard.vue?vue&type=script&lang=js"
import style0 from "./InvoiceExcelDashboard.vue?vue&type=style&index=0&id=2e1cf132&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e1cf132",
  null
  
)

export default component.exports